import { Card, CardBody } from "reactstrap";

const ReplaySequenceCard = () => {
  return (
    <>
      <Card className="card card-grow w-100 mx-auto mb-3">
        <CardBody className="text-center">
          <h4>Replay Sequence</h4>
        </CardBody>
      </Card>
    </>
  );
};

export default ReplaySequenceCard;
